export default class AttributeIconUtil {
	public static getIcon(type: string | undefined, attributeId: string, system: boolean): string | undefined {
		if (attributeId === 'name' || attributeId === 'givenName' || attributeId === 'surname') {
			return 'PersonIcon';
		} else if (attributeId === 'email') {
			return 'EmailIcon';
		} else if (attributeId === 'phoneNumber') {
			return 'PhoneIcon';
		} else if (type === 'date' || type === 'datetime') {
			return 'CalendarIcon';
		} else if (type === 'text') {
			return 'TextIcon';
		} else if (type === 'number') {
			return 'NumberIcon';
		} else if (type === 'decimal') {
			return 'DecimalIcon';
		} else if (attributeId.indexOf('flow.') === 0) {
			return 'QuestionIcon';
		} else if (!system) {
			return 'CustomAttributeIcon';
		}
	}
}
